import React from "react";
import AddInquiryToCustomerForm from "../../Request/AddInquiryToCustomerForm";
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../../services/ReactQuery/reactQueryService";
import Typography from "@mui/material/Typography";
import { ProductUnion } from "../../../types/ProductUnion";
import { InquiryToCustomer } from "../../../types/InquiryToCustomer";

interface AddInquiryModalProps {
  product: ProductUnion;
  handleClose: Function;
  editorPlaceholder?: string;
  conversationId?: number;
  draft?: Partial<InquiryToCustomer>;
  overwrittenHandleSave?: Function;
}

export default function AddInquiryToCustomerDrawer({
  handleClose,
  product,
  editorPlaceholder,
  conversationId,
  draft,
  overwrittenHandleSave,
}: AddInquiryModalProps) {
  let inquiryFilter = {
    productId: product.id,
    "status[lt]": 40,
  };
  const { data: caseOpenInquiries } = useQuery({
    queryKey: queryKeys.collection("inquiry_to_customers", inquiryFilter),
    queryFn: () => fetchCollection("inquiry_to_customers", inquiryFilter),
    enabled: !!product
  });

  if (!caseOpenInquiries) {
    return null;
  }

  if (caseOpenInquiries["hydra:totalItems"] > 1) {
    return (
      <Typography>
        Es sind bereits zwei Anfragen an die Mandantschaft gestellt worden. Diese Anfragen müssen erst abschließend
        bearbeitet oder geschlossen werden, damit eine neue Anfrage gestellt werden kann.
      </Typography>
    );
  }

  return (
    <AddInquiryToCustomerForm
      draft={draft}
      handleClose={handleClose}
      product={product}
      editorPlaceholder={editorPlaceholder}
      conversationId={conversationId}
      overwrittenHandleSave={overwrittenHandleSave}
    />
  );
}
